import { useCallback, useEffect, useState } from "react";
import { listPartnerListings } from "../../api/partnerApi";
import RequirePermission from "../../auth/RequirePermission";

function PartnerListingsContent() {
  const [listings, setListings] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const loadListings = useCallback(async () => {
    try {
      setIsLoading(true);
      setErrorMessage("");
      const body = await listPartnerListings({
        search: search.trim() || undefined,
        status: status || undefined,
        limit: 100,
      });
      setListings(body.listings || []);
      setTotal(body.total || 0);
    } catch (error) {
      setListings([]);
      setErrorMessage(error.message || "Unable to load listings.");
    } finally {
      setIsLoading(false);
    }
  }, [search, status]);

  useEffect(() => {
    loadListings();
  }, [loadListings]);

  return (
    <section className="panel-card">
      <h2>Listings ({total})</h2>
      <div className="admin-users-toolbar">
        <input
          type="search"
          placeholder="Search address or city"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
        />
        <select value={status} onChange={(event) => setStatus(event.target.value)}>
          <option value="">All statuses</option>
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
          <option value="STALE_CANDIDATE">Stale candidate</option>
        </select>
        <button type="button" className="midpoint-share-button" onClick={loadListings}>
          Refresh
        </button>
      </div>

      {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}
      {isLoading ? <p className="muted">Loading…</p> : null}

      {!isLoading && listings.length ? (
        <table className="admin-data-health-table account-security-table">
          <thead>
            <tr>
              <th>Address</th>
              <th>Type</th>
              <th>Price</th>
              <th>Status</th>
              <th>Source</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            {listings.map((listing) => (
              <tr key={listing.listingId}>
                <td>
                  {listing.addressLine || listing.neighborhood || listing.city || "—"}
                  {listing.publicUrl ? (
                    <>
                      {" "}
                      <a href={listing.publicUrl} target="_blank" rel="noreferrer">
                        View
                      </a>
                    </>
                  ) : null}
                </td>
                <td>{listing.listingType || listing.propertyType || "—"}</td>
                <td>
                  {listing.price != null
                    ? `${listing.currency || ""} ${listing.price}`.trim()
                    : "—"}
                </td>
                <td>{listing.status || "—"}</td>
                <td>{listing.sourceDisplayName || listing.sourceCode}</td>
                <td>{listing.updatedAt ? new Date(listing.updatedAt).toLocaleString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}

      {!isLoading && !listings.length && !errorMessage ? (
        <p className="muted">No listings in your partner scope.</p>
      ) : null}
    </section>
  );
}

const PartnerListingsPage = () => (
  <RequirePermission permission="partner_listings.view">
    <PartnerListingsContent />
  </RequirePermission>
);

export default PartnerListingsPage;
